<template>
    <div>
        <div class="">
            <div class="card-body">
                <div class="search-org position-relative">
                    <input type="text" class="form-control pe-4" v-model="searchWeakness" placeholder="Select Catalogue">
                    <i class="fa fa-search"></i>
                </div>
                <div class="vulnerable mt-3">
                    <ul class="list-group">
                        <li class="list-group-item" v-for="v in vuln" :key="v.ID">
                            <div v-on:click="selectedVuln = v">
                                <span v-if="v.ID == selectedVuln.ID" class="text-success me-2"><i class="fa fa-check"></i></span>
                                {{ v.title }}
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="card-body">
                <WeaknessCal :key="reload" :impact="report.impact" :likelihood="report.likelihood" :fixeffort="report.fixeffort" :risk="report.risk" v-on:callback="getCallback" />
            </div>
            <div class="card-body">
                <div class="card">
                    <div class="card-header">
                        <h3>Details</h3>
                    </div>
                    <div class="card-body">
                        <div class="row">
                            <div class="col-md-6 col-12">
                                <label>Title</label>
                                <input type="text" class="form-control" v-model="report.title">
                            </div>
                            <div class="col-md-6 col-12">
                                <label>Summary</label>
                                <input type="text" class="form-control" v-model="report.summary" disabled="true">
                            </div>
                        </div>
                    </div>
                    <div class="card-body">
                        <label>Description</label>
                        <VueEditor v-model="description" :editorToolbar="this.$customToolbar"></VueEditor>
                    </div>
                </div>
            </div>
            <div class="card-body">
                <div class="card">
                    <div class="card-header">
                        <h3>Evidence</h3>
                    </div>
                    <div class="card-body">
                        <input type="file" id="file" ref="file" accept="image/png, video/mp4" class="form-control" v-on:change="handleFileUpload()">
                        <small class="text-danger">Upload image or video evidence. For images, only .png files can be used.</small>
                    </div>
                    <div v-if="report_id != 0" class="card-body">
                        <div class="row">
                            <div v-for="pic in report.picture" :key="pic.ID" class="col-3 position-relative">
                                <div v-if="pic.picture != ''">
                                    <img :src="'data:image/png;base64,' + pic.picture" class="img-thumbnail evidence" v-if="pic.file_type != 'video/mp4'">
                                    <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAOEAAADhCAMAAAAJbSJIAAAAflBMVEX///8UFBQAAADb29sQEBC8vLwKCgpERETo6OgaGhqvr6/FxcWRkZF2dnYODg5sbGz09PTMzMyAgIDx8fErKysjIyMcHByLi4vr6+vh4eGoqKhZWVnT09OXl5c2Njaenp5OTk5TU1NgYGBFRUUvLy+Dg4NnZ2c1NTWjo6Otra2kwj/4AAAGh0lEQVR4nO2d63aiPBSGNSKeEc/SVm2t7XTu/waHQ0WEBLI3MZnOvM+vb61vku4HIuSwEzodAAAAAAAAAAAAAAAAAAAAAAAAAAAAQDui/uFzsBmNtpvB56E/JBQcT8/HpOD6fX6a7B8XYSsWs7WI8QPP8wI/+c/LcqFRLuzPN6WCx93Lw8Olsp/GUQbdewIh1odVfcFo6VULxprHr9BO5HrsZ9Uoc8lljWN0FsKTFowlD3+P40EIaZQp8S06qQouGwqObVqo6W1qwsxCXUeygpM6v6zge0Mbt8JJ+PVxdpMm91QtuFQ07CJCTOwblZgrfkfluzErlQtfG27gteDBidaNN604k7txviu3umgXXDpSy9C7EVmkb4VyqzWhYPn22+RZP877u3gkFfxwJrikxBlHursWJF2ZuOBvR4JjWpxxpP2s4I5csOdEMNJ6ihbxRNqnXlAFu/7aiSHhKXMl+yluml+glYIuforkNppGGrfTKaugg3bqNfdIqsTNbcUR7Ipn64JfrEDjm/jBLKgz1DQK+TGT4a155ezfxD7vTsSKzHJdIR2fPA7iO9sAYmpVkPe4aEWwtWrIelW0xO4LY+7C8Mum4YXzMmxr+GlR0MHPMOnVWjSk951NICzOLrp40Nh91JzcGFrsuJGHsGYM+/YMidMXpgwtToH/+4bMEVBbQ4ut9ODG0OIMv6O3hcVl04kbQ4ur30M3hvYEOx3+UJ2P/2rT8Oxi9GR1kM+caWtnaHW2LbJvaHXwFHOkz8y3xPYyov1mantKOOQaNuVfqPAvdgXZnW9xYD6G7efW7FnT+p4IX1iG9m8hcxSc5I6wbqLNccWVcEufUUzXcoeMu3+XyGENRvc7ex7SZ3k8QchVNciMnHDwnYyhnWaUF3SVjDEgJo28fpcLR7T+gpg7EuysupRI/W0+o9vTSNorCL6zotv3DMwgRxp5ibmgXxjALghPG/GLFelJCBMP4Eg7XyG43I3QXwJdRX/AEZys42sYmFgH0J6x8d9m8wKzo+al8bqM2ZnoOWtcrdcBerVZzGVFcYf2D9ETmx1tgibMw2ppOFRmoRsmyYYnNLen22VvZ/jFHSVw0M+GXlwKl72V4czO/bsSqBP+i0Tnu6d7G0P7C/kaCd/hrtSuWhi6WF5rfLuNu+V2xTd0Muft1c95vwyqz2e+IWPgZIC6IdRqLutesQ3dLD3VTUYp9iWxDd3cQnV+Yn+kuORcQzcrT2nEsoFw71XZQeIakke+xpCMhFezmp4H13DjqJHKhsKn2p4V03Cl6s0EvilUl9Af3IeSjpHMG8pXZZKNrQNTrBV9+mBT7IFHb00jFKZhT2YojkYnNMMnX/ZXPO9mGGoM3Qwaml8YCmXTXAXD3zpDG3OGj0ikl80454aLo9bQxqBh+p4Kh6ZI/45kO8C34fBTcwbMmGG2nWknzJEuNFXfSpnhVHvsbc4wGbqZ7OkE6TCiuoSTGI4JcyfmDMcd5oYtZWjJpEW17+RtJwPK3MLPM4z/B2k94CcaEquBIQzzimBIDw2GmtXAEIZ5RTCkhwZDzWpgCMO8IhjSQ4OhZjUwhGFeEQzpocFQsxoYwjCvCIb00GCoWQ0MYZhXBEN6aDDUrAaGMMwrgiE9NBhqVgNDGOYVwZAe2v9rSNts9QMNt1vShjKzmXuUrb1N+CL5+kr1rGKvG9anrpcDM2Xop9t1nswlX27SzTGjyiVLchPDmX5um8EM2kecRC3ZYpzll/bedffYmjMs7xIwwd6vtvprFnR/o/eTMJnJ/mz6fNih7AsKt0x2vTxho7sRtl8mP80UTaU/tkKu/vCs8XM0aZhsuBbbkRm2QpHpHD9Lb3Hc7Wk2aqg8UtAzh+IvBPffKmncc8Hd2WV3F3eR8sGCla3NJbiGA+tnteURV75udT0fQvHvmYZG+2ckZNu5J7/UbYprKH/UWMCTn1WiPt2BvQ/YVTNVfYItVO0jZRu62gisPg9LsReYvx/f/hdK0nh3NSFJO3J8Q86Ra61p+nCXZE9+i3MxJvYVg8Yz2/aVcxXanG0ytq3o65x1XT4bo9X5NH3aHqu2iJFesGOv2FTbnTEUHUmHrrXCF5/ao7NiR67tSVhjyWecH6InBpTzZ/e3cVX7b35MZhtzkzMqjh/U88zyfdBGvmqyWvQfygtr8uApEMYM/1KS8wg84ebTl7aInv03N6eeAgAAAAAAAAAAAAAAAAAAAAAAAAAA8PP4A92ChzskeU2QAAAAAElFTkSuQmCC" class="img-thumbnail evidence" v-else title="video evidence">
                                </div>
                                <div v-else>
                                    <img src="@/assets/img/vue-logo.png" class="img-thumbnail evidence" title="Empty evidence in active">
                                </div>
                                <button type="button"
                                    v-on:click="removeEdivence(pic.ID)"
                                    class="delete-evidence btn btn-danger btn-sm"
                                    >
                                        <i class="fa fa-times"></i>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="card-body">
                <div class="card">
                        <div class="card-header">
                            <h3>Actions/Further Information</h3>
                        </div>
                        <div class="card-body">
                            <strong>Actions</strong>
                            <div class="actionholder">
                                <draggable tag="ul" :list="actions" class="list-group" handle=".handle">
                                    <li
                                    class="list-group-item"
                                    v-for="(element, idx) in actions"
                                    :key="element.ID"
                                    >
                                        <div v-if="element.content != ''">
                                            <i class="fa fa-align-justify handle me-2"></i>
                                            <input type="checkbox"
                                            v-on:change="UpdateActionData(element, has_action[element.ID], $event)" :checked="!isNaN(has_action[element.ID])" v-if="report_id != 0"
                                            class="ms-2 me-2">
                                            <input type="checkbox" class="me-3" v-on:change="addActionData(idx, element, $event)" :checked="!isNaN(has_action[element.ID])" v-else>


                                            <span class="text">{{ element.content }}</span>
                                            <i class="fa fa-times close float-end" @click="removeAt(idx)"></i>
                                        </div>
                                        <div v-else>
                                            <i class="fa fa-align-justify handle"></i>
                                             <input class="ms-2 me-2 actionField" type="text" v-model="other_action[idx]" >
                                            <i class="fa fa-times close float-end" @click="removeAt(idx, 'other')"></i>
                                        </div>
                                    </li>
                                </draggable>

                                <draggable tag="ul" class="list-group" handle=".handle">
                                    <li
                                    class="list-group-item hideifempty"
                                    v-for="(element, idx) in report.action"
                                    :key="element.ID"
                                    >
                                        <div v-if="element.action_id == 0">
                                            <i class="fa fa-align-justify handle me-2"></i>
                                            <input type="text" class="ms-2 me-2 actionField" v-model="report.action[idx].title">
                                            <i class="fa fa-times close float-end" @click="removeActionCustom(report.action[idx])"></i>
                                        </div>
                                    </li>
                                </draggable>
                                <button class="btn btn-outline-info  btn-sm mt-2" @click="add">Add</button>
                            </div>

                        </div>
                        <div class="card-body">
                            <strong>Further Information</strong>
                             <div class="actionholder">
                                <draggable tag="ul" :list="further" class="list-group" handle=".handle">
                                    <li
                                    class="list-group-item"
                                    v-for="(element, idx) in further"
                                    :key="element.ID"
                                    >
                                        <div v-if="element.content != ''">
                                            <i class="fa fa-align-justify handle me-2"></i>
                                            <input
                                                type="checkbox"
                                                class="me-3"
                                                v-on:change="UpdateFurtherData(element, has_further[element.ID], $event)" :checked="!isNaN(has_further[element.ID])"
                                                v-if="report_id != 0">

                                            <input
                                                type="checkbox"
                                                class="me-3"
                                                v-on:change="addFurtherData(idx, element, $event)" :checked="!isNaN(has_further[element.ID])"
                                                v-else>
                                            <span class="text">{{ element.content }} </span>
                                            <i class="fa fa-times close float-end" @click="removeAtFurther(idx)"></i>
                                        </div>
                                        <div v-else>

                                            <i class="fa fa-align-justify handle"></i>
                                             <input type="text" class="ms-2 me-2 actionField" v-model="other_further[idx]" >
                                            <i class="fa fa-times close float-end" @click="removeAtFurther(idx, 'other')"></i>
                                        </div>
                                    </li>
                                </draggable>
                                <draggable tag="ul" class="list-group" handle=".handle">
                                    <li
                                    class="list-group-item hideifempty"
                                    v-for="(element, idx) in report.further"
                                    :key="element.ID"
                                    >
                                        <div v-if="element.further_id == 0">
                                            <i class="fa fa-align-justify handle"></i>
                                                <input type="text" v-model="report.further[idx].title" class="ms-2 me-2 actionField">
                                            <i class="fa fa-times close float-end" @click="removeFurtherCustom(report.further[idx])"></i>
                                        </div>
                                    </li>
                                </draggable>

                                <button class="btn btn-outline-info  btn-sm mt-2" @click="addFurther">Add</button>
                            </div>
                        </div>
                    </div>
            </div>

            <div class="card-body">
                <button type="submit"
                    class="btn btn-outline-info rounded-pill"
                    title="Save"
                    @click.prevent="create">{{ title }}
                </button>
            </div>

        </div>
    </div>
</template>
<script>
import WeaknessCal from '../Tools/weaknessCal.vue'
import { VueEditor } from "vue2-editor";
import draggable from 'vuedraggable'
export default {
    props: {
        project_id: Number,
        report_id: Number
    },
    components: {
        WeaknessCal,
        VueEditor,
        draggable
    },
    data() {
         return {
             title: 'Submit Vulnerability',
             vuln: [],
             searchWeakness: '',
             selectedVuln: [],
             org_id: this.$route.params.org_id,

             reload: Math.random(),
             report: {
                impact: 'Moderate',
                likelihood: 'Possible',
                fixeffort: 'Low',
                risk: 'Medium',
                picture: [],

                weakness_id : '',
                title: '',
                summary: '',
                description: '',
                action: [],
                further: [],

                // picture: []
             },
             description: '',
             other_action: [],
             other_further: [],
             actions: [],
             further: [],

             has_action: [],
             has_further: [],
         }
     },
     mounted() {
         this.init();
     },
     watch: {
         searchWeakness: function(val) {
            const me = this;
            this.$axios.get(this.$server + 'weakness?s=' + val)
            .then(res => {
                if (res.data.success) {
                    me.vuln = res.data.data;
                }
            });
         },

         selectedVuln: function(val) {

            // if (this.report_id != 0) {
            //     if (confirm("Updating catalogue will remove some actions and further information")) {
            //         console.log(1);
            //     }
            // }
            this.report =  val;
            this.report.summary = val.title;
            this.report.discription = '';
            this.report.weakness_id = val.ID;


            // reset data
            this.actions = val.actions;
            this.report.action = [];
            // this.other_action = [];

            // reset data
            this.further = val.further_informations;
            this.report.further = [];
            // this.other_further = [];


            this.reload = Math.random();

         },

         description: function(val) {
             this.report.description = val;
         }
     },
     methods : {
         removeAt(idx, typ = "action") {
             if (typ == "other") {
                 this.other_action.splice(idx, 1);
             }
             this.actions.splice(idx, 1);
         },
         removeAtFurther(idx, typ = "further") {
             if (typ == "other") {
                 this.other_further.splice(idx, 1);
             }
             this.further.splice(idx, 1);
         },
         add: function() {
            if (this.report_id != 0) {
                this.report.action.push({"title":"", "action_id": 0});
            } else {
                this.actions.push({"content": ""});
            }
         },
         addFurther: function() {
             this.further.push({"content": ""});
         },

         handleFileUpload() {
            console.log(this.$refs.file.files[0]);
             this.report.picture = this.$refs.file.files[0];
         },
         addActionData(index, act, event) {
             var me = this;
            if (event.target.checked) {
                me.report.action.push({'title': act.content, 'project_id' :  me.project_id, 'action_id': act.ID });
            } else {
                me.report.action.splice(index, 1);
            }
         },

         removeActionCustom: function(action) {
             var me = this;
             if (confirm("Are you sure you want to remove this to the report?")) {
                    this.$axios.delete(this.$server + 'organisation/'+ this.org_id +'/project/'+  me.project_id +'/report/' + me.report_id + '/action/' + action.ID)
                .then(res => {
                    if (res.data.success) {
                        me.$swal({
                           title: res.data.message
                       });

                    }
                });
             }
             me.init();
         },
         removeFurtherCustom: function(further) {
             var me = this;
             if (confirm("Are you sure you want to remove this to the report?")) {
                    this.$axios.delete(this.$server + 'organisation/'+ this.org_id +'/project/'+  me.project_id +'/report/' + me.report_id + '/further/' + further.ID)
                .then(res => {
                    if (res.data.success) {
                        me.$swal({
                           title: res.data.message
                       });

                    }
                });
             }
             me.init();
         },
         UpdateActionData: function(list, action_id, event) {
             var me = this;
             if (!event.target.checked) {
                 if (confirm("Are you sure you want to remove this to the report?")) {
                     this.$axios.delete(this.$server + 'organisation/'+ this.org_id +'/project/'+  me.project_id +'/report/' + me.report_id + '/action/' + action_id)
                    .then(res => {
                        if (res.data.success) {
                            me.$swal({
                               title: res.data.message
                            });

                        }
                    });
                }
             } else {
                this.$axios.post(this.$server + 'organisation/'+ this.org_id +'/project/'+  me.project_id +'/report/' + me.report_id + '/action', {
                        'action_id' : list.ID,
                        'title' : list.content
                    })
                .then(res => {
                    if (res.data.success) {
                        me.$swal({
                           title: res.data.message
                       });
                    }
                });

            }

            me.init();
         },
         UpdateFurtherData: function(list, further_id, event) {
             var me = this;
             if (!event.target.checked) {
                 if (confirm("Are you sure you want to remove this to the report?")) {
                     this.$axios.delete(this.$server + 'organisation/'+ this.org_id +'/project/'+  me.project_id +'/report/' + me.report_id + '/further/' + further_id)
                    .then(res => {
                        if (res.data.success) {
                            me.$swal({
                               title: res.data.message
                            });

                        }
                    });
                }
             } else {
                this.$axios.post(this.$server + 'organisation/'+ this.org_id +'/project/'+  me.project_id +'/report/' + me.report_id + '/further', {
                        'further_id' : list.ID,
                        'title' : list.content
                    })
                .then(res => {
                    if (res.data.success) {
                        me.$swal({
                           title: res.data.message
                       });
                    }
                });
            }

            me.init();
         },
         addFurtherData(index, act, event) {
             var me = this;
             if (event.target.checked) {
                me.report.further.push({'title': act.content, 'project_id' :  this.project_id, 'further_id': act.ID });
             } else {
                me.report.further.splice(index, 1);
             }
         },
         removeEdivence(pic_id) {
             var me = this;
             if (confirm("Are you sure you want to delete?")) {
                this.$axios.delete(this.$server + 'organisation/'+ this.org_id +'/project/'+  this.project_id +'/report/' + this.report_id + '/evidence/' + pic_id)
                .then(res => {
                    if (res.data.success) {
                        me.$swal({
                           title: res.data.message
                       });
                    }
                });
                this.init();
             }
         },
         getCallback(val) {
            this.report.impact = val.impact;
            this.report.likelihood = val.likelihood;
            this.report.fixeffort = val.fixeffort;
            this.report.risk = val.risk;

        },

        init: function() {
            // load weakness
            const me = this;
            this.$axios.get(this.$server + 'weakness')
            .then(res => {
                if (res.data.success) {

                    me.vuln = res.data.data;

                    // call report after weakness load

                    if (this.report_id != 0) {
                        this.title = "Update Vulnerability";
                        this.$axios.get(this.$server + 'organisation/'+ this.org_id +'/project/'+  this.project_id +'/report/' + this.report_id)
                        .then(res => {
                            if (res.data.success) {
                                var rep = res.data.report[0];
                                me.description = rep.description;
                                for (var w in me.vuln) {
                                    if (me.vuln[w].ID == rep.weakness_id) {
                                        me.selectedVuln = me.vuln[w];
                                    }
                                }

                                // replace weakness data
                                setTimeout(function(){
                                    me.report  = rep;
                                    me.reload = Math.random();
                                }, 1000);

                                for (var i in rep.action) {
                                    me.has_action[rep.action[i].action_id] = rep.action[i].ID;

                                }

                                for (var e in rep.further) {
                                    me.has_further[rep.further[e].further_id] = rep.further[e].ID;
                                }
                            }
                        });
                    }
                }
            });

        },

        create () {
            const me = this;
            var method = 'post';
            var host = this.$server + 'organisation/'+ this.org_id +'/project/'+  this.project_id +'/report';

            if (this.report_id != 0) {
                method = 'put';
                host = host + '/' + this.report_id;
            }


            // convert to form data
            if (this.other_action.length > 0) {
                for (var othr in this.other_action) {
                     this.report.action.push({'title': this.other_action[othr], 'project_id' :  this.project_id, 'action_id': 0});
                }
            }

            if (this.other_further.length > 0) {
                for (var othr2 in this.other_further) {
                     this.report.further.push({'title': this.other_further[othr2], 'project_id' :  this.project_id, 'action_id': 0});
                }
            }

            var form_data = new FormData();

            for ( var key in this.report ) {
                if (typeof this.report[key] === 'object') {
                    if (key != "picture") {
                        this.report[key] =  JSON.stringify(this.report[key]);
                    }
                }

                form_data.append(key, this.report[key]);
            }


            this.$axios({
                method: method,
                url: host,
                headers: {
                    'Content-Type': 'multipart/form-data'
                },
                data: form_data
            })
            .then(res => {
                var r = res.data;
                if (r.success) {
                    me.$swal({
                        title: r.message
                    });

                    if (document.getElementById("btnReport") != null) {
                        document.getElementById("btnReport").click();
                    }
                    me.$emit('callback', Math.random());
                }
            });
        }
     }
}
</script>